import { render } from "./DivisionPlanOpportunitiesComponent.vue?vue&type=template&id=68d7647f"
import script from "./DivisionPlanOpportunitiesComponent.vue?vue&type=script&lang=js"
export * from "./DivisionPlanOpportunitiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__